﻿import { JsonServiceClient } from '@servicestack/client';
import { useMemo } from 'react';
import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { client } from '../api/client';
import { GetAllSpeakerInformationByGuid, GetAllSpeakerInformationById, GetAllSpeakerInformationByIdResponse } from '../api/dtos';
import { useGet } from '@ngt/forms';

const getData = (response?: SWRResponse<GetAllSpeakerInformationByIdResponse, GetAllSpeakerInformationByIdResponse>) => response?.data?.registration;

const getError = (response?: SWRResponse<GetAllSpeakerInformationByIdResponse, GetAllSpeakerInformationByIdResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetAllSpeakerInformationByIdResponse, GetAllSpeakerInformationByIdResponse>) => ({
    registration: response?.data?.registration
});

export const useSpeaker = (guid?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        
        return () => {
            return new GetAllSpeakerInformationByGuid({guid});
        };
    }, [guid])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useSpeaker;